/* eslint-disable prettier/prettier */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next"
// Stylings

const InnerContainer = styled.div`
  width: 520px;
  height: 250px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  position: absolute;
  font-family: "Roboto", sans-serif;
  z-index: 100;
  animation: zoomIn 0.2s ease-in-out;
  position: fixed;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const TextContainer = styled.div`
  height: 58%;
`;
const Br = styled.div`
  height: 15%;
`;
const HeaderText = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 50%;
  color: ${(props) => props.theme.colors.black};
  height: 23%;
`;
const ParagraphText = styled.div`
  font-size: 16px;
  line-height: 135%;
  color: ${(props) => props.theme.colors.black};
  width: 85%;
  display: inline-table;
`;
const ButtonContainer = styled.button`
  width: 40%;
  height: 80%;
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  cursor: pointer;
  border: none;
`;
const ButtonContainerLine = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: space-evenly;
  margin-top: -23px;
`;
const GetStartedButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`;
const ShowInfoButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.darkGreen};
  width: 100%;
`;
// TODO: Fix this, this is temporary fix
export default function ResizePopUp({
  browserName,
  setResizePopup,
  resizePopUpShown,
  percentage,
  originalPercentage
}) {
  const [percent, setPercentage ] = useState(0);
  const { t, ready, i18n } = useTranslation()

  useEffect(()=>{
    console.log("useEffect resizePopup")
    setTimeout(()=>{
      setPercentage(percentage)
    }, 1000)
  },[i18n.language, ready, percentage])

  console.log("recieved", percentage, "percent")
  if (resizePopUpShown) {
    if (browserName == "Firefox") {
      return (
        <InnerContainer >
          <Br />
          <TextContainer>
            {percentage > 0 ? <HeaderText>
              {t('modals.browser_resolution.large_resolution_title')}
            </HeaderText> : <HeaderText>
            {t('modals.browser_resolution.small_resolution_title')}
            </HeaderText>}
            {percentage > 0 ? <ParagraphText>
              {t('modals.browser_resolution.info_text_zoom_out')}
            </ParagraphText> : <ParagraphText>
            {t('modals.browser_resolution.info_text_zoom_in')}
            </ParagraphText>}
          </TextContainer>
          <ButtonContainerLine>
            <ButtonContainer
              onClick={() => {
                setResizePopup(false);
              }}
            >
              <GetStartedButton>{t('modals.browser_resolution.button1')}</GetStartedButton>
            </ButtonContainer>
          </ButtonContainerLine>
        </InnerContainer>
      );
    }
    return (
      <InnerContainer >
        <Br />
        <TextContainer>
          {percentage < 0 ? <HeaderText>
            {t('modals.browser_resolution.large_resolution_title')}
          </HeaderText> : <HeaderText>
          {t('modals.browser_resolution.small_resolution_title')}
          </HeaderText>}
          {percentage < 0 ? <ParagraphText>
            {t('modals.browser_resolution.info_text_zoom_out')}
          </ParagraphText> : <ParagraphText>
          {t('modals.browser_resolution.info_text_zoom_in')}
          </ParagraphText>}
        </TextContainer>
        <ButtonContainerLine>
          <ButtonContainer
            onClick={() => {
              setResizePopup(false);
            }}
          >
              <GetStartedButton>{t('modals.browser_resolution.button1')}</GetStartedButton>
          </ButtonContainer>
        </ButtonContainerLine>
      </InnerContainer>
    );
  }
  return null;
};
